import { initializeApp } from "firebase/app";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDoOuuVn6Od_eXszjOOni_2xwOr_9A2eJo",
  authDomain: "yshaleh.firebaseapp.com",
  projectId: "yshaleh",
  storageBucket: "yshaleh.firebasestorage.app",
  messagingSenderId: "705459933475",
  appId: "1:705459933475:web:e4e83c394e1afdc33dbc96",
  measurementId: "G-GQ6778S5BT",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

if (process.env.REACT_APP_USE_EMULATORS === "true" && !globalThis.__yshalehFsEmu) {
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  globalThis.__yshalehFsEmu = true;
}

export default app;
